import { render, staticRenderFns } from "./MasterSetupBox.vue?vue&type=template&id=77a3115a&scoped=true&"
import script from "./MasterSetupBox.vue?vue&type=script&lang=js&"
export * from "./MasterSetupBox.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=77a3115a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a3115a",
  null
  
)

export default component.exports